import { Routes } from "@angular/router";
import { AdminGuard } from "../guard/admin.guard";
import { AgentsListComponent } from "../../components/apps/agents/agents-list/agents-list.component";
import { roleGuard } from "../guard/role.guard";

export const content: Routes = [
  {
    path: "chat",
    loadChildren: () => import("../../components/apps/chat/chat.module").then((m) => m.ChatModule),
    // canActivate: [roleGuard],
    // data: { roles: ['admin', 'agent'] }
  },
  {
    path: "agent-history",
    loadChildren: () => import("../../components/apps/chat/chat.module").then((m) => m.ChatModule),
    // canActivate: [roleGuard],
    // data: { roles: ['admin', 'agent'] }
  },
  {
    path: "faqs",
    loadChildren: () => import("../../../app/components/apps/faq/faq.module").then((m) => m.FaqModule),
    // canActivate: [roleGuard],
    // data: { roles: ['admin'] }
  },
  {
    path: "dashboard",
    loadChildren: () => import("../../../app/components/apps/agents/agents.module").then((m) => m.AgentsModule)
    // canActivate: [roleGuard],
    // data: { roles: ['admin'] }
  },
];
